/* eslint-disable react/no-danger */
import React from 'react';

/**
 * Componente CaptionMC
 * Renderiza el caption de un mensaje multimedia con estilos consistentes.
 * Props:
 *   - caption: string (HTML seguro)
 */
const CaptionMC = ({ caption, className = '' }) => {
  if (!caption) return null;
  return (
    <div
      className={`tw-text-sm tw-font-normal tw-mt-2 tw-break-words tw-whitespace-pre-line tw-p-2 tw-mb-2 ${className}`}
      dangerouslySetInnerHTML={{ __html: caption }}
    />
  );
};

export default CaptionMC;
